import toast from "react-hot-toast";
import useApi from "../useApi";

const useDeleteResource = ({ resourceId }: { resourceId?: string }) => {
  const { loading: deleteResourceLoading, makeApiCall } = useApi({
    url: `/RTM/files/${resourceId}`,
    method: "DELETE",
  });

  const deleteResource = async () => {
    if (!resourceId) {
      toast.error("Invalid resource ID.");
      return { status: false };
    }

    const { error } = await makeApiCall<undefined, undefined>();

    if (error) {
      toast.error("Something went wrong while deleting the resource. Please try again later.");
      return { status: false };
    } else {
      toast.success("File deleted successfully.");
      return { status: true };
    }
  };

  return {
    deleteResourceLoading,
    deleteResource,
  };
};

export default useDeleteResource;
